// extracted by mini-css-extract-plugin
module.exports = {"SweepstakesPage":"SweepstakesRules_SweepstakesPage__2TOG7"};